import React from "react";
import { Link } from "react-router-dom";

const Terms = () => {
    return (
        <>
            <div className="pt-10 pb-10 bg-black text-gray-400">
                <div className="max-w-4xl mx-auto px-6">
                    <h1 className="text-3xl font-bold mb-8 text-green">Terms and Conditions for Game Gems</h1>
                    <p className="mb-4"><strong>Effective Date:</strong> July 30, 2025</p>

                    <p className="mb-6">Welcome to <strong>Game Gems</strong>! These Terms and Conditions ("Terms") govern your access to and use of our mobile application. By downloading or using the app, you agree to these Terms.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">1. Acceptance of Terms</h2>
                    <p className="mb-4">By accessing or using the Game Gems app, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the app.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">2. Use of the App</h2>
                    <ul className="list-disc list-inside mb-4 space-y-1">
                        <li>You must be at least 13 years old or the minimum age in your country to use the app.</li>
                        <li>You agree not to use the app for any illegal or unauthorized purpose.</li>
                        <li>You must not attempt to hack, reverse engineer, or damage the app or its functionality.</li>
                    </ul>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">3. User Accounts</h2>
                    <p className="mb-4">If you create an account with us, you are responsible for maintaining the confidentiality of your login credentials and all activities that occur under your account.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">4. Virtual Rewards</h2>
                    <p className="mb-4">Game Gems may allow users to collect virtual rewards (such as gems or coins). These have no real-world monetary value and are for entertainment purposes only.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">5. Intellectual Property</h2>
                    <p className="mb-4">All content, branding, and materials within the app are owned by Game Gems or its licensors. You may not use, copy, or distribute our content without permission.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">6. Termination</h2>
                    <p className="mb-4">We reserve the right to suspend or terminate your access to the app at any time for violations of these Terms or suspected fraudulent activity.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">7. Modifications</h2>
                    <p className="mb-4">We may update or modify these Terms at any time. Continued use of the app after changes constitutes your acceptance of the updated Terms.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">8. Disclaimer</h2>
                    <p className="mb-4">Game Gems is provided "as is" and "as available." We make no warranties, express or implied, regarding the availability, accuracy, or reliability of the app.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">9. Limitation of Liability</h2>
                    <p className="mb-4">To the fullest extent permitted by law, Game Gems shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the app.</p>

                    <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">10. Contact Us</h2>
                    <p className="mb-4">If you have any questions about these Terms, please contact us at: <Link to="mailto:gamegems.help@gmail.com">gamegems.help@gmail.com</Link></p>

                    <p><em>By using this app, you agree to abide by these Terms and Conditions.</em></p>
                </div>
            </div>
        </>
    )
}

export default Terms;